import { cardeal } from './api';

export class TabelaContribuicaoService {
  calcularContribuicao = async (matricula, renda, plano) => {
    const response = await cardeal.get('CalcularContribuicao', {
      params: {
        matricula,
        plano,
        renda,
      },
    });
    return response.data;
  };
}
